import { getObjectTypeIconComponent } from 'customer-data-objects-ui-components/objects/getObjectTypeIconComponent';
import { ContactsIcon } from 'foundations-assets/icons/components/ContactsIcon';
import { CustomObjectIcon } from 'foundations-assets/icons/components/CustomObjectIcon';
const BREEZE_ICON_OVERRIDES = {
  '0-1': ContactsIcon
};
export const getBreezeObjectTypeIcon = objectTypeId => getObjectTypeIconComponent(objectTypeId, {
  DefaultIconComponent: CustomObjectIcon,
  overrides: BREEZE_ICON_OVERRIDES
});